import { render, staticRenderFns } from "./MergeRequest.vue?vue&type=template&id=19709e83&scoped=true"
import script from "./MergeRequest.vue?vue&type=script&lang=js"
export * from "./MergeRequest.vue?vue&type=script&lang=js"
import style0 from "./MergeRequest.vue?vue&type=style&index=0&id=19709e83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19709e83",
  null
  
)

export default component.exports